export const BUTTON_TYPE = {
    PRIMARY: "primary",
    PRIMARY_LIGHT_WITH_BORDER: "primary-light-with-border",
    LIGHT_WITH_NO_BORDER: "light-with-no-border",

    DANGER: "danger"
}